import { render, staticRenderFns } from "./productIterations.vue?vue&type=template&id=71e4c0cd&scoped=true&"
import script from "./productIterations.vue?vue&type=script&lang=js&"
export * from "./productIterations.vue?vue&type=script&lang=js&"
import style0 from "./productIterations.vue?vue&type=style&index=0&id=71e4c0cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4c0cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e4c0cd')) {
      api.createRecord('71e4c0cd', component.options)
    } else {
      api.reload('71e4c0cd', component.options)
    }
    module.hot.accept("./productIterations.vue?vue&type=template&id=71e4c0cd&scoped=true&", function () {
      api.rerender('71e4c0cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/roadmap/productIterations.vue"
export default component.exports